import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Box,
  Flex
} from "@chakra-ui/react";

interface InfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  headerText?: string;
}

const InfoModal: React.FC<InfoModalProps> = ({ isOpen, onClose, children, headerText }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
      <ModalContent borderRadius="lg" maxW="570px" position="relative">
        {headerText && (
          <ModalHeader 
            fontSize="md" 
            fontWeight="semibold" 
            pb={2}
            pt={4}
            pl={6}
            pr={12}
          >
            {headerText}
          </ModalHeader>
        )}
        <Flex position="absolute" top="1" right="1" zIndex="10">
          <ModalCloseButton 
            position="static" 
            size="sm"  
            top={headerText ? "12px" : "8px"}
            right={headerText ? "12px" : "8px"}
          />
        </Flex>
        <ModalBody p={0} pt={headerText ? 0 : 6}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default InfoModal; 